// What the gorillas say.
//
// A line is a bubble over one gorilla's head that lives for a fixed time. This
// module knows nothing about what any particular line means: callers pass the
// text, which keeps each joke next to the thing it is about.
//
// Bubbles are deliberately not part of the antic pose. A gorilla can be chest
// beating while it shouts, and a line that arrives with a hit has to survive the
// antic being cancelled so the aiming hand can line up.

import { state } from './state.js';
import { BUBBLE_MS } from './config.js';

/**
 * Nobody gets to have more than this many lines waiting. In practice the two
 * sides can only ever have one each, so it exists to catch a bug rather than to
 * manage a crowd.
 */
const MAX_BUBBLES = 3;

/**
 * Puts a line in the air over gorilla `idx`. A new line replaces that gorilla's
 * own, so nobody talks over themselves — but both sides can be shouting at once,
 * which is most of the fun.
 */
export function say(idx, text, ms = BUBBLE_MS) {
  if (!state.bubbles) state.bubbles = [];

  state.bubbles = state.bubbles.filter(b => b.idx !== idx);
  state.bubbles.push({ idx, text, born: state.clock, ms });

  if (state.bubbles.length > MAX_BUBBLES) state.bubbles.shift();
}

/** What a gorilla is saying right now, or null. */
export function bubbleFor(idx) {
  return (state.bubbles || []).find(b => b.idx === idx) || null;
}

/** How far through its life a bubble is: 0 the moment it is said, 1 when it is gone. */
export function bubbleAge(b) {
  return b.ms > 0 ? Math.min(1, (state.clock - b.born) / b.ms) : 1;
}

/** Drops the expired ones. Called once a frame by the render loop. */
export function advanceBubbles() {
  if (!state.bubbles || !state.bubbles.length) return;

  state.bubbles = state.bubbles.filter(b => bubbleAge(b) < 1);
}

/** Silences everyone at once, for the start of a match. */
export function hush() {
  state.bubbles = [];
}
